<template>
  <div>
    <router-link :to="to" class="back-link">＜ 戻る</router-link>
  </div>
</template>

<script>

export default {
  props: ['to']
}
</script>

<style lang="scss" scoped>

  .back-link {
    font-size: 14px;
  }

</style>
